The input parameter for the `createWebhookSubscription` mutation.
